import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatDate', function formatDate (value) {
  var date = new Date(value)
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return year + '-' + month + '-' + day
})
Vue.filter('formatDateTime', function formatDateTime (value) {
  var date = new Date(value)
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()
  var hours = date.getHours()
  var minutes = date.getMinutes()
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes
})
Vue.filter('formatDateTimeUct', function formatDateTime (value) {
  var date = new Date(value)
  return moment(date).utc().format('YYYY-MM-DD HH:mm:ss')
})
Vue.filter('formatDateTimeUctYMD', function formatDateTime (value) {
  var date = new Date(value)
  return moment(date).utc().format('YYYY-MM-DD')
})



// WEBPACK FOOTER //
// ./src/utils/filter_utils.js